import { registerLanguage } from '../_.contribution.js';

registerLanguage({
  id: "pla",
  extensions: [".pla"],
  loader: () => import('./pla.js')
});
